import React, {Component} from 'react';
import LineItem from './LineItem';
import ReactGA from 'react-ga';

class Cart extends Component {
    constructor(props) {
        super(props);
        // console.log('cart props: ', props)
        this.openCheckout = this.openCheckout.bind(this);
        ReactGA.initialize('UA-71072433-1');
    }

    openCheckout() {
        // ReactGA.event({category: 'user', action: 'add_to_cart'});
        var ga = ReactGA.ga();
        ga('event', 'add_to_cart', {
            "items": [
                {
                    "id": "hea-course",
                    "name": "Happily Ever After",
                    "category": "course",
                    "list_position": 1,
                    "quantity": 1,
                    "price": '97'
                }
            ]
        });
        window.open(this.props.checkout.webUrl);
    }

    render() {
        let line_items = this.props.checkout.lineItems.map((line_item) => {
            return (
                <LineItem
                    updateQuantityInCart={this.props.updateQuantityInCart}
                    removeLineItemInCart={this.props.removeLineItemInCart}
                    key={line_item.id.toString()}
                    line_item={line_item}
                />
            );
        });

        return (
            <div className={`Cart ${this.props.isCartOpen ? 'Cart--open' : ''}`}>
                <header className="Cart__header">
                    <h2>Your cart</h2>
                    <button
                        onClick={this.props.handleCartClose}
                        className="Cart__close">
                        ×
                    </button>
                </header>
                <ul className="Cart__line-items">
                    {line_items}
                </ul>
                <footer className="Cart__footer">
                    <div className="Cart-info clearfix">
                        <div className="Cart-info__total Cart-info__small">Subtotal</div>
                        <div className="Cart-info__pricing">
                            <span className="pricing">$ {this.props.checkout.subtotalPrice}</span>
                        </div>
                    </div>
                    <div className="Cart-info clearfix">
                        <div className="Cart-info__total Cart-info__small">Taxes</div>
                        <div className="Cart-info__pricing">
                            <span className="pricing">$ {this.props.checkout.totalTax}</span>
                        </div>
                    </div>
                    <div className="Cart-info clearfix">
                        <div className="Cart-info__total Cart-info__small">Total</div>
                        <div className="Cart-info__pricing">
                            <span className="pricing">$ {this.props.checkout.totalPrice}</span>
                        </div>
                    </div>
                    <button className="Cart__checkout button" onClick={this.openCheckout}>Checkout</button>
                </footer>
            </div>
        )
    }
}

export default Cart;
